import { Button, Modal, ModalBody, ModalHeader } from "Components/ReactstrapSlim";
import React, { useEffect, useState } from "react";
import { useApiClient } from "Services/API/useApiClient";
import { AccountClient } from "Services/LegacyAPI/AccountClient";

export interface TermsOfUseModalProps {
   show: boolean,
   onAccept: () => void;
}

export const TermsOfUseModal: React.FC<TermsOfUseModalProps> = ({ show, onAccept }) => {
   const [isOpen, setIsOpen] = useState(false);
   const accountClient = useApiClient(AccountClient);
   const [termOfUseHtml, setTermOfUseHtml] = useState<string>("");

   const getTermsOfUseHtml = async () => {
      setTermOfUseHtml((await accountClient.termsOfUseHtml()).termOfUseHtml);
   }

   const toggle = () => {
      setIsOpen((open) => !open);
   }

   useEffect(() => {      
      if (isOpen && !termOfUseHtml) {
         getTermsOfUseHtml();
      }
   }, [isOpen])

   useEffect(() => {
      setIsOpen(show);
   }, [show])

   return (<Modal className="terms-modal" isOpen={isOpen} toggle={toggle} centered>
            <ModalHeader toggle={toggle} lightWordsCount={1}>Accept Terms of Use</ModalHeader>
            <ModalBody className="terms-modal-body">
               <div className="terms-modal-form">
                  <div dangerouslySetInnerHTML={{ __html: termOfUseHtml }} className="terms-modal-terms">
                  </div>
                  <Button onClick={onAccept} color="primary" size="md" fluid className="terms-modal-cta">Accept</Button>
               </div>
            </ModalBody>
         </Modal>)
}